import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AdminMember {
  user_id: string;
  first_name: string | null;
  last_name: string | null;
  avatar_url: string | null;
  displayName: string;
}

export function useAdminMembers() {
  return useQuery({
    queryKey: ["admin-members"],
    queryFn: async (): Promise<AdminMember[]> => {
      // Get all users with admin/super_admin roles
      const { data: roleRows, error: roleError } = await supabase
        .from("user_roles")
        .select("user_id")
        .in("role", ["admin", "super_admin"]);

      if (roleError) throw roleError;
      if (!roleRows?.length) return [];

      const userIds = roleRows.map((r) => r.user_id);

      const { data: profiles, error: profileError } = await supabase
        .from("profiles")
        .select("user_id, first_name, last_name, avatar_url")
        .in("user_id", userIds);

      if (profileError) throw profileError;

      return (profiles || []).map((p) => ({
        user_id: p.user_id,
        first_name: p.first_name,
        last_name: p.last_name,
        avatar_url: p.avatar_url ?? null,
        displayName:
          [p.first_name, p.last_name].filter(Boolean).join(" ") || "Unbenannt",
      }));
    },
    staleTime: 5 * 60 * 1000,
  });
}
